// A colour's lighter and darker tones, `#rrggbb` in and out (an `#rrggbbaa`
// keeps its alpha). Pure: the ceiling's default colour (ceiling.ts), the
// heater wall's (main.ts) and the plan's ceiling marks (render.ts) read it.

const HEX = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})?$/i;

function toned(hex: string, f: (c: number) => number): string {
  const m = HEX.exec(hex.trim());
  if (!m) return hex;
  const c = (i: number): string => Math.round(f(parseInt(m[i], 16))).toString(16).padStart(2, '0');
  return '#' + c(1) + c(2) + c(3) + (m[4] ?? '');
}

const clamp01 = (k: number): number => Math.max(0, Math.min(1, k));

/** `hex` moved toward white by `amount` (0..1). Anything that is no hex colour
 *  is returned as it is. */
export function lightenHex(hex: string, amount: number): string {
  const k = clamp01(amount);
  return toned(hex, (c) => c + (255 - c) * k);
}

/** `hex` moved toward black by `amount` (0..1). */
export function darkenHex(hex: string, amount: number): string {
  const k = clamp01(amount);
  return toned(hex, (c) => c * (1 - k));
}
